import React from 'react';

const SUPPORT_EMAIL = 'aevdir.com@gmail.com';

const COPY = {
  en: {
    title: 'Support',
    lead:
      'Need a hand or have feedback? Drop us a line — we read every message and usually reply within a business day.',
    sectionTitle: 'Contact support',
    sectionDesc: 'For account issues, event suggestions, bug reports or partnership enquiries.',
    emailLabel: 'Email',
    sendEmail: 'Send email',
    tipsTitle: 'Before you email',
    tips: [
      'Tell us what you were trying to do and what actually happened.',
      'Include the page URL and, if possible, a screenshot.',
      'Mention your account email so we can look up your records.',
    ],
  },
  zh: {
    title: '支持',
    lead: '遇到问题或有任何建议？欢迎来信——我们会认真阅读每一封邮件，通常在一个工作日内回复。',
    sectionTitle: '联系支持',
    sectionDesc: '账号问题、活动建议、Bug 反馈或商务合作均可联系我们。',
    emailLabel: '邮箱',
    sendEmail: '发送邮件',
    tipsTitle: '写邮件前的小贴士',
    tips: [
      '说明你在做什么，以及实际发生了什么。',
      '附上页面链接，如果方便的话附上截图。',
      '请写上你的账号邮箱，方便我们查询记录。',
    ],
  },
};

function MailIcon() {
  return (
    <svg
      className="support-icon"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3 7 9 6 9-6" />
    </svg>
  );
}

function SupportPage({ lang }) {
  const t = COPY[lang === 'zh' ? 'zh' : 'en'];

  return (
    <section className="support-page">
      <header className="support-hero">
        <h1 className="support-title">{t.title}</h1>
        <p className="support-lead">{t.lead}</p>
      </header>

      <div className="support-card">
        <h2 className="support-section-title">{t.sectionTitle}</h2>
        <p className="support-section-desc">{t.sectionDesc}</p>

        <div className="support-contact-row">
          <span className="support-contact-icon" aria-hidden="true">
            <MailIcon />
          </span>
          <div className="support-contact-body">
            <div className="support-contact-label">{t.emailLabel}</div>
            <a className="support-contact-value" href={`mailto:${SUPPORT_EMAIL}`}>
              {SUPPORT_EMAIL}
            </a>
          </div>
          <a className="support-contact-action" href={`mailto:${SUPPORT_EMAIL}`}>
            {t.sendEmail}
          </a>
        </div>
      </div>

      <div className="support-card support-card-tips">
        <h3 className="support-tips-title">{t.tipsTitle}</h3>
        <ul className="support-tips-list">
          {t.tips.map((tip, idx) => (
            <li key={idx}>{tip}</li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default SupportPage;
